import "./styles/animations.css";

interface LoadingProps {
  dark?: boolean;
  /** Diámetro del spinner en px (por defecto 80) */
  size?: number;
  /** Sobreescribe el color de los puntos, para superficies de color fijo */
  dotClassName?: string;
}

function Loading({ dark = true, size = 80, dotClassName }: LoadingProps) {
  const dotColor =
    dotClassName ?? (dark ? "bg-text-primary" : "bg-background-100");
  const scale = size / 80;

  const positions = [
    { top: 63, left: 63 },
    { top: 68, left: 56 },
    { top: 71, left: 48 },
    { top: 72, left: 40 },
    { top: 71, left: 32 },
    { top: 68, left: 24 },
    { top: 63, left: 17 },
    { top: 56, left: 12 },
  ];

  return (
    <div
      className="inline-block relative"
      style={{ width: `${size}px`, height: `${size}px` }}
      title="spinner-loading"
    >
      {positions.map((pos, i) => (
        <div
          key={i}
          className="absolute animate-spinner"
          style={{
            animationDelay: `${-0.036 * (i + 1)}s`,
            transformOrigin: `${40 * scale}px ${40 * scale}px`,
          }}
        >
          <div
            className={`absolute rounded-full ${dotColor}`}
            style={{
              width: `${7 * scale}px`,
              height: `${7 * scale}px`,
              top: `${pos.top * scale}px`,
              left: `${pos.left * scale}px`,
              margin: `${-4 * scale}px 0 0 ${-4 * scale}px`,
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default Loading;
